export default __webpack_public_path__ + "static/media/english_gray.a934ebb4.svg";